import script from "./RecommendedVehicleComponents.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendedVehicleComponents.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendedVehicleComponents.vue?vue&type=style&index=0&id=4d15f374&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d15f374"]])

export default __exports__